import { Component, Input } from '@angular/core';

import { Gto } from '../base/vo/gto';
import { JustificativaToken } from '../base/vo/justificativa-token';


@Component({
  selector: 'app-gto-token',
  templateUrl: './gto-token.component.html',
  styleUrls: ['./gto-token.component.scss']
})
export class GtoTokenComponent {

  @Input() gto: Gto;
  @Input() tokenMensagem: string;

  public displayModal = false;
  public justificatinonList: JustificativaToken[] = [];

  public loading = false;

  public step = 0;

  public changeStep($event: number) {
    this.step = $event;
  }

  public openDialog() {
    this.step = 0;
    this.displayModal = true;
  }

  public closeDialog() {
    this.step = 0;
    this.displayModal = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/gto-token/gto-token.component.ts